import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkButton } from './uitk-button.esm.js';

var UitkOverlayButton = /** @class */ (function (_super) {
    __extends(UitkOverlayButton, _super);
    function UitkOverlayButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkOverlayButton.prototype.render = function () {
        var _a = this.props, className = _a.className, props = __rest(_a, ["className"]);
        var classNameOverlayButton = classNames("".concat(UitkButton.baseClassName, "-overlay"), className);
        return React.createElement(UitkButton, __assign({}, props, { className: classNameOverlayButton }));
    };
    UitkOverlayButton.displayName = 'UitkOverlayButton';
    return UitkOverlayButton;
}(React.Component));

export { UitkOverlayButton };
